import { useFormState } from 'react-final-form'
import { QuoteModeEnum, type QuoteMode } from 'types/projects'

/** Canonical quick-quote check — single source for SPA behaviour gates. */
export function isQuickQuote(quoteMode: QuoteMode | null | undefined): boolean {
  return quoteMode === QuoteModeEnum.QUICK_QUOTE
}

/** Stable analytics payload for home quote mode selection / project create events. */
export function getQuoteModeTrackingPayload(quoteMode: QuoteMode | null | undefined) {
  const resolved = quoteMode ?? QuoteModeEnum.NORMAL
  return {
    quote_mode: resolved,
    quote_mode_label: isQuickQuote(resolved) ? 'quick_quote' : 'design_project',
  }
}

/** Read ``quote_mode`` from the nested project form (Manage / project sections). */
export function useIsQuickQuote(): boolean {
  const values = useFormState().values as { quote_mode?: QuoteMode } | undefined
  return isQuickQuote(values?.quote_mode)
}
